import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.StepTypeEditor', {
    label: 'Approval condition:',
    stepTypeDefault: 'All',
    stepTypeAnyOf: 'Any of',
    stepTypeAnyOfCount: 'Any {count} of selected',
});
